module.exports = __webpack_public_path__ + "media/club_product_v2/3-3595fed8.webp";